<div class="form851-taxualinfo">

  <!-- INITIAL LOADING STATE - shown when waiting for filter selection -->
  @if (loadingData) {
<div class="gg-loader">
    <div class="gg-loader-text">
      <img src="assets/img/arrow-filter-sm.png" alt="">
    </div>
  </div>
}

  <!-- MAIN CONTENT - shown after initialization -->
  @if (!loadingData) {
<div>

    <!-- FORM LOADER - shown while fetching data after filter selection -->
    @if (showLoader) {
<div class="form-loader">
      <div class="css-spinner"></div>
    </div>
}

    @if (!showLoader) {
<div class="container-fluid container-border">
  <div class="inner-container">
    <div class="divShadow">
      <div class="table-responsive-md">
        <form name="localDescForm" id="screenFrom" class="form-horizontal" novalidate>
          <div class="table-responsive">
            <div style="margin-center: 25px; text-align: center">
              <label><h3>Part III</h3></label>
            </div>
            <table class="gt-reclass-table table table-hover table-bordered table-striped table-condensed custom-table">
              <thead>
                <tr>
                  <th style="width: 2%"></th>
                  <th style="width: 88%"></th>
                  <th style="width: 10%"></th>
                </tr>
              </thead>
              <tbody>
                @for (row of tbl_list; track $index) {
<tr>
                  @if (row.FIELD_TYPE === 'CHECKBOX') {
<td>{{ row.LINE_NO }}</td>
}
                  @if (row.FIELD_TYPE === 'TEXT' && row.SNO === '1') {
<td>{{ row.LINE_NO }}</td>
}
                  @if (row.FIELD_TYPE === 'CHECKBOX') {
<td>{{ row.ATTRIB_DESC }}</td>
}
                  @if (row.LINE_NO === '(e)' && row.SNO === '1') {
<td>
                    {{ row.ATTRIB_DESC }}
                    <table class="subTable">
                      <tr>
                        <th></th>
                        <th style="padding: 0 !important; width: 72px; background-color: transparent !important; border: none;">
                          <div class="col-md-1 col-md-btn gt-edit-col">
                            <i class="fa fa-plus-circle color-green" (click)="addE()"></i>
                          </div>
                        </th>
                      </tr>
                      @for (account of sublist; track $index; let i = $index) {
<tr>
                        <td><input type="text" class="form-control" [(ngModel)]="account.ATTRIB_VALUE" name="sublist_{{i}}"></td>
                        <td style="text-align: center;">
                          <div class="col-md-1 col-md-btn gt-edit-col">
                            <i class="fa fa-minus-circle color-red" (click)="removeE(i)"></i>
                          </div>
                        </td>
                      </tr>
}
                    </table>
                  </td>
}
                  @if (row.LINE_NO === '(f)' && row.SNO === '1') {
<td>
                    {{ row.ATTRIB_DESC }}
                    <table class="subTable">
                      <tr>
                        <th></th>
                        <th style="padding: 0 !important; width: 72px; background-color: transparent !important; border: none;">
                          <div class="col-md-1 col-md-btn gt-edit-col">
                            <i class="fa fa-plus-circle color-green" (click)="addF()"></i>
                          </div>
                        </th>
                      </tr>
                      @for (account of sublist1; track $index; let i = $index) {
<tr>
                        <td><input type="text" class="form-control" [(ngModel)]="account.ATTRIB_VALUE" name="sublist1_{{i}}"></td>
                        <td style="text-align: center;">
                          <div class="col-md-1 col-md-btn gt-edit-col">
                            <i class="fa fa-minus-circle color-red" (click)="removeF(i)"></i>
                          </div>
                        </td>
                      </tr>
}
                    </table>
                  </td>
}
                  @if (row.FIELD_TYPE === 'CHECKBOX') {
<td>
                    <input type="radio" style="margin-top: 10px;" [(ngModel)]="row.ATTRIB_VALUE" value="Yes" [name]="'radio_' + row.LINE_NO"> Yes
                    <input type="radio" style="margin-left: 7px" [(ngModel)]="row.ATTRIB_VALUE" value="No" [name]="'radio_' + row.LINE_NO"> No
                  </td>
}
                </tr>
}
              </tbody>
            </table>
          </div>
        </form>
      </div>
    </div>
    <div class="modal-footer">
      <button class="save-button btn btn-info btn-sm" type="button" (click)="save()"
        [disabled]="!tbl_list?.length || crudLoading">
        @if (crudLoading) {
<span><i class="fa fa-spinner fa-pulse"></i></span>
} Save
      </button>
      <button class="reset-button btn btn-warning btn-sm" type="button" (click)="reset()"
        [disabled]="!tbl_list?.length">Reset</button>
    </div>
  </div>
    </div>
} <!-- closes !showLoader -->
  </div>
} <!-- closes !loadingData -->
</div> <!-- closes form851-taxualinfo -->
